import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  createColor,
  getColor,
  getColors,
  editColor,
  deleteColor,
} from "api/colorApi";

export const COLOR_QUERY_KEY = "colors";

export const useColors = (params = {}) => {
  return useQuery({
    queryKey: [COLOR_QUERY_KEY, params],
    queryFn: () => getColors(params),
    keepPreviousData: true,
  });
};

export const useColor = (id) => {
  return useQuery({
    queryKey: [COLOR_QUERY_KEY, id],
    queryFn: () => getColor(id),
    enabled: !!id,
  });
};

export const useCreateColor = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createColor,
    onSuccess: (data) => {
      if (data?.success) queryClient.invalidateQueries([COLOR_QUERY_KEY]);
    },
  });
};

export const useEditColor = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: editColor,
    onSuccess: (data) => {
      if (data?.success) queryClient.invalidateQueries([COLOR_QUERY_KEY]);
    },
  });
};

export const useDeleteColor = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteColor,
    onSuccess: (data) => {
      if (data?.success) queryClient.invalidateQueries([COLOR_QUERY_KEY]);
    },
  });
};
